import { brandUrl, fetchFromBrandedUrl } from "@/api/utils";

import { AxiosRequestConfigMethods } from "@/api/types";
import {
  ListingsResponse,
  ListingsQueryParams,
} from "@/modules/listing-dashboard/dtos/index-v2";
import { EnvironmentVariables } from "@/modules/common/types";
import { BasePaginationParams } from "@/modules/common/dtos/index.v2";
import { ListingType } from "@/modules/property-tracks/dtos";

// Map frontend filter keys to backend API keys
const mapFiltersToApiParams = (filters: any) => {
  const mapped = { ...filters };

  // No mapping needed - backend now accepts compoundIds directly
  // Keep compoundIds as is (backend expects compoundIds)
  // Keep propertyTypeIds as is (backend expects propertyTypeIds with IDs)
  // Keep assignedUserUIds as is (already correct)
  // Keep trackStatusUIds as is (already correct)
  // Keep unitId as is (already correct)
  // Keep readyToMoveListingsOnly as is (already correct)

  return mapped;
};

export const getListingsDashboardV2 = async ({
  listingType,
  initialFilters,
  filters,
  pagination,
}: {
  listingType: ListingType;
  initialFilters: Partial<ListingsQueryParams>;
  filters: Partial<ListingsQueryParams>;
  pagination: BasePaginationParams;
}) => {
  const apiUrl = brandUrl<ListingsResponse>(
    `${EnvironmentVariables.PROPERTY_MANAGEMENT_API_URL}/listings`
  );

  // Map filter keys to match backend expectations
  const mappedInitialFilters = mapFiltersToApiParams(initialFilters);
  const mappedFilters = mapFiltersToApiParams(filters);

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
      params: {
        listingType,
        ...pagination,
        ...mappedInitialFilters,
        ...mappedFilters,
      },
    },
  }) as Promise<ListingsResponse>;
};

export const updateListingPriceV2 = async ({
  updateListingRequest,
  propertyUid,
  trackUid,
}: {
  updateListingRequest: {
    paymentType: "cash" | "installments";
    priceRole: "listing" | "asking";
    askingPrice?: number;
    price?: number;
    downPayment?: number;
    remainingInstallments?: number;
    maintenance?: number;
    clubhouse?: number;
    parking?: number;
  };
  propertyUid: string;
  trackUid?: string;
}) => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.PROPERTY_MANAGEMENT_API_URL}/properties/${propertyUid}/price`
  );
  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.PUT,
      data: { ...updateListingRequest, trackUid },
    },
  });
};

export const moveListingV2 = async ({
  trackUid,
  journeyUId,
}: {
  trackUid: string;
  journeyUId: string;
}) => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.PROPERTY_MANAGEMENT_API_URL}/tracks/${trackUid}/move-journey`
  );
  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.PATCH,
      data: { journeyUId },
    },
  });
};
